import { HttpEvent, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { FormSubmissionService } from '@app/finxone-web-frontend/app/lib/services/form-submission-service/form-submission-service.service';
import {
  getFormActionType,
  uploadFilesValidation,
} from '@app/finxone-web-frontend/app/lib/utils/upload-file-utils/upload-file-utils';
import { getFileType } from '@app/finxone-web-frontend/app/lib/utils/utils';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  BaseCssProperties,
  ProviderClass,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { FormActionTypeEnum } from 'libs/shared/enums/form-action.enum';
import { tap } from 'rxjs';
import { FormSubmitter } from '../widgets/form-widgets/form-submitter/form-submitter.component';
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrl: './upload-file.component.scss',
})
export class UploadFileComponent extends FormSubmitter implements OnInit {
  public buttonLabel = 'Upload';
  uploadFileIcon: string | undefined;
  iconSize: baseCssConfigStyle;
  label = 'Upload Images (Maximum limit:  ';
  files: any[] = [];
  suportedFileType = '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf';
  maxFileUpload = '5';
  selectedEntityOption: string | 'bulk_payments';
  fileUploads = '';
  isWorkflow: boolean;
  public baseStyle: baseCssConfigStyle;
  constructor(
    private configService: ConfigService,
    protected override store: Store,
    public dataIn: ProviderClass<any>,
    private formSubmissionService: FormSubmissionService,
    private alertHandlerService: AlertHandlerService,
  ) {
    super(store);
    if (this.dataIn != undefined) {
      this.attri = this.dataIn.attri;
    }
  }
  ngOnInit() {
    this.files = [];
    this.label = this.attri?.['uploadFileLabel'];
    this.maxFileUpload = this.attri?.['maxFileUpload'] ?? this.maxFileUpload;
    this.buttonLabel = this.attri?.['widgetProperties']?.['textContent'];

    if (this.dataIn != undefined) {
      this.selectedEntityOption = this.attri?.['selectedEntityOption'];
      if (this.attri?.['uploadType'] == 'image') {
        this.suportedFileType = 'image/*';
      } else {
        this.suportedFileType = '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf,.csv';
      }
      this.uploadFileIcon = this.attri?.['widgetProperties']?.icon;
      this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
        BaseCssProperties.MARGIN,
        BaseCssProperties.PADDING,
        BaseCssProperties.BORDER,
        BaseCssProperties.V_ALIGN,
        BaseCssProperties.TEXTALIGN,
        BaseCssProperties.BACKGROUND_COLOR,
        BaseCssProperties.COLOR,
        BaseCssProperties.BOX_SHADOW,
        BaseCssProperties.FONT_SIZE,
        BaseCssProperties.TEXT_BOLD,
        BaseCssProperties.TEXT_ITALIC,
        BaseCssProperties.TEXT_UNDERLINE,
      ]);
      this.baseStyle = this.configService.getSpecificBaseCssStyle(this.attri, [BaseCssProperties.MARGIN]);

      this.iconSize = this.configService.getSpecificBaseCssStyle(this.attri, [BaseCssProperties.ICON_SIZE]);
    }
    this.subscribeToFormAction(FormActionTypeEnum.CUSTOM_QUESTION).subscribe((response) => {
      if (response?.['formData']?.['myFiles']) {
        this.files = response['formData']['myFiles'];
      }
    });

    this.isWorkflow = this.configService.getActiveConfigType().isWorkflow;
  }

  async fileBrowseHandler(event: any) {
    const filesUploaded = this.files.length
      ? this.files.length + event.target.files.length
      : event.target.files.length;
    if (filesUploaded <= this.maxFileUpload) {
      const isValCheck = await uploadFilesValidation(
        this.selectedEntityOption,
        this.alertHandlerService,
        event.target.files,
      );
      if (isValCheck) {
        this.prepareFilesList(event.target.files);
      } else {
        this.fileUploads = '';
      }
    } else {
      this.alertHandlerService.showAlertFn('error', 'You can select max' + this.maxFileUpload + ' files');
    }
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.hasSizeError = false;
      item.progress = 0;
      const uploadType = this.attri?.['uploadType'];
      const itemType = item.type.split('/')[0];

      if (item.size > 2097152) {
        const msg = 'Cant upload ' + item.name + ', it exceeds the limit of 2 MB.';
        this.alertHandlerService.showAlertFn('error', msg);
        item.hasSizeError = true;
        return;
      } else if (
        (uploadType === 'image' && itemType !== 'image') ||
        (uploadType !== 'image' && itemType === 'image')
      ) {
        this.fileUploads = '';
        this.alertHandlerService.showAlertFn('error', 'File Format is not Allowed!');
        return;
      }
    }
    this.uploadFiles(files);
  }
  uploadFiles(files: File[]) {
    const formData: FormData = new FormData();
    if (files.length) {
      for (const file of files) {
        formData.append('myfiles', file);
        this.selectedEntityOption === 'bulk_payments'
          ? formData.append('category', 'document')
          : formData.append('category', 'image');
      }
    }
    this.configService
      .uploadFile(formData, {
        private: this.selectedEntityOption === 'bulk_payments' ? true : false,
      })
      .pipe(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.onSaveFormValuesToState(event.body);
            this.fileUploads = '';
            this.alertHandlerService.showAlertFn('success', 'You successfully updated the file.');
          }
        }),
        tap({
          error: (error: any) => {
            this.fileUploads = '';
            let msg;
            if (typeof error?.error?.message === 'string') {
              msg = error.error.message;
            } else {
              msg = error?.error?.message?.join(', ');
            }
            this.alertHandlerService.showAlertFn('error', msg ?? 'Internal server error');
          },
        }),
      )
      .subscribe();
  }

  public onSaveFormValuesToState(eventBody: any) {
    for (const uploadFile of eventBody) {
      this.files.push(uploadFile);
    }
    this.syncDataWithFormAction();
  }

  syncDataWithFormAction() {
    const formValues = this.files?.map((item) => {
      return {
        id: item.id,
        path: item.path,
        fileType: getFileType(item.filename),
        entityType: this.selectedEntityOption,
        filename: item.filename,
      };
    });
    this.formSubmissionService
      .submitIndividualForm({ myFiles: formValues }, '', getFormActionType(this.selectedEntityOption))
      .then();
  }

  delFile(id: string) {
    this.fileUploads = '';
    this.files = this.files.filter((file) => {
      return file.id !== id;
    });
    this.syncDataWithFormAction();
  }
}
